export default function FormControl() {
  return {
    MuiFormControl: {
      defaultProps: {
        size: 'small',
      },
    },
  };
}
